import React, { useEffect, useRef } from "react";
import { motion, useReducedMotion } from "framer-motion";
import { hasPaintedOnce, markPainted } from "./firstPaint";

const pageVariants = {
  initial: {
    opacity: 0,
    y: 20,
  },
  animate: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.3,
      ease: [0.4, 0, 0.2, 1],
    },
  },
  exit: {
    opacity: 0,
    transition: {
      duration: 0.15,
      ease: [0.4, 0, 0.2, 1],
    },
  },
};

function PageTransition({ children }) {
  // Always a motion.div. This used to return a plain <div> on the first render
  // and a <motion.div> on every render after it, which changes the ELEMENT TYPE
  // at the same position in the tree — so React tore down and rebuilt the entire
  // page on the first state update. On /chat that meant typing one character
  // remounted the textarea and dropped focus, and every keystroke after the
  // first went nowhere. Skipping the entrance animation is a prop, not a branch.
  const reduceMotion = useReducedMotion();
  const skipEntrance = useRef(!hasPaintedOnce()).current || reduceMotion;
  useEffect(() => {
    markPainted();
  }, []);

  return (
    <motion.div
      initial={skipEntrance ? false : "initial"}
      animate="animate"
      exit={reduceMotion ? undefined : "exit"}
      variants={pageVariants}
      style={{ width: "100%", minHeight: "100vh" }}
    >
      {children}
    </motion.div>
  );
}

export default PageTransition;
